import React, { lazy } from 'react';
import DashboardLayout from 'src/layouts/DashboardLayout';
import {
  AuthGuard, GuestGuard, MainLayout
} from '@nsd/fe';

import {
  Build as ServiceIcon,
  BusinessCenter as ClientsIcon,
  CalendarViewDay as DispatchScheduleIcon,
  DynamicFeed as WorkflowIcon,
  Settings as SettingsIcon,
  Beenhere as BeenhereIcon,
} from '@material-ui/icons';
import GuestLayout from 'src/layouts/GuestLayout';
import CallCenterFilter from 'src/components/CallCenterFilter';
import IncompleteSessionIcon from 'src/components/IncompleteSessionIcon';

const appIcon = 'https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/dispatchQoreAppIcon.png';

const MODULE = {
  CLIENTS: 'clients-be7a45bc-46f7-4f42-b60d-671fd5cca165',
  CUSTOMERS: 'customers-1309455d-1682-448c-a3fb-cf366f772a94',
  DASHBOARD: 'dashboard-c58f06d6-c457-4aa2-9beb-63cfd33641a4',
  DISPATCH_BOARD: 'dispatchBoard-e9a15b8c-bec6-4635-bcd3-61c70e5fd77f',
  DISPATCH_CONTROL: 'dispatchControl-b95b999e-c399-468f-9f3a-2bd730686512',
  CLIENTS_CREATE: 'clientsAdd-efcdb8ef-43de-49ba-abc2-2d83a43764dc',
  CLIENTS_EDIT: 'clientsEdit-2e89a567-71eb-486d-b7c2-fe770144a65f',
  CUSTOMERS_CREATE: 'customersCreate-3111774a-9d31-4d10-8d14-0afbb7c3b54b',
  CUSTOMERS_EDIT: 'customersEdit-73a75a49-4a0b-42c0-b7eb-0afd70140c73',
  DISPATCH_WORKFLOWS: 'dispatchWorkflows-4ccdf87a-7e92-4572-9d9d-ac006c2f6a05',
  DISPATCH_WORKFLOWS_CREATE: 'dispatchWorkflowsAdd-6ef2089a-963b-432f-a7ef-58a2a6512ad5',
  DISPATCH_WORKFLOWS_EDIT: 'dispatchWorkflowsEdit-13eec6b3-6fc9-42f6-8cd8-351951bc23a4',
  POLICY_VERIFICATION_HISTORY: 'policyVerificationHistory-b3c8d4a5-9e2f-4a1c-8b7d-f2c1e6a9b0d3',
  SERVICES: 'services-b11c4964-f7bc-459c-b5fd-3328614a241c',
  SERVICES_CREATE: 'servicesCreate-ba84bc9b-7819-4865-a9a2-b3cdf7e5bb47',
  SERVICES_EDIT: 'servicesEdit-ce867682-33d9-4291-a7b2-ee36be2cbdda',
  SETTINGS: 'settings-8a38cbef-e5bb-4f62-85d4-c084c4f2fda0',
  PROGRAMS: 'settings-8a38cbef-e5bb-4f62-85d4-c084c4f2fda0',
  SESSIONS: 'incompleteDispatchSessions-0bc5e532-b2cb-4658-ba46-5f1955c7ceb9'
};

const sharedNavConfig = {
  navBarItems: [
    // As per https://nationsafedrivers.atlassian.net/browse/DD2-2795
    // we are commenting out this module until we rework dashboard page and api route
    /* {
      subheader: 'app.navigation.reports',
      items: [
        {
          title: 'app.navigation.dashboard',
          icon: PieChartIcon,
          href: 'reports/dashboard',
          module: MODULE.DASHBOARD
        }
      ]
    }, */
    {
      subheader: 'app.navigation.dispatching',
      items: [
        {
          title: 'app.navigation.dispatchBoard',
          href: '/dispatch/dispatch/dispatch-schedule',
          module: MODULE.DISPATCH_BOARD,
          icon: DispatchScheduleIcon
        },
        {
          title: 'Incomplete Sessions',
          href: '/dispatch/session/incomplete-sessions',
          module: MODULE.SESSIONS,
          icon: IncompleteSessionIcon
        }
      ]
    },
    // {
    //   subheader: 'Development',
    //   items: [
    //     {
    //       title: 'Integrations',
    //       icon: DevelopIcon,
    //       href: '/dispatch/management/dispatch-integration',
    //       items: [
    //         {
    //           title: 'List Integrations',
    //           href: '/dispatch/management/dispatch-integration'
    //         }
    //       ]
    //     }
    //   ]
    // },
    {
      subheader: 'app.navigation.management',
      items: [
        {
          title: 'app.navigation.clients',
          icon: ClientsIcon,
          href: '/dispatch/management/clients',
          module: MODULE.CLIENTS,
          items: [
            {
              title: 'List Clients',
              href: '/dispatch/management/clients',
              module: MODULE.CLIENTS
            }
          ]
        },
        // As per https://nationsafedrivers.atlassian.net/browse/DD2-2795
        // we are commenting out this module until customer endpoint has been fixed.
        /* {
          title: 'app.navigation.customers',
          icon: CustomersIcon,
          href: '/dispatch/management/customers',
          module: MODULE.CUSTOMERS,
          items: [
            {
              title: 'List Customers',
              href: '/dispatch/management/customers',
              module: MODULE.CUSTOMERS
            }
          ]
        }, */
        {
          title: 'app.navigation.services',
          icon: ServiceIcon,
          href: '/dispatch/management/services',
          module: MODULE.SERVICES,
          items: [
            {
              title: 'List Services',
              href: '/dispatch/management/services',
              module: MODULE.SERVICES
            }
          ]
        },
        {
          title: 'app.navigation.dispatchWorkflows',
          icon: WorkflowIcon,
          href: '/dispatch/management/workflows',
          module: MODULE.DISPATCH_WORKFLOWS,
          items: [
            {
              title: 'List Workflows',
              href: '/dispatch/management/workflows',
              module: MODULE.DISPATCH_WORKFLOWS
            }
          ]
        },
        {
          title: 'app.navigation.policyVerificationHistory',
          icon: BeenhereIcon,
          href: '/dispatch/management/policy-verification-history',
          module: MODULE.POLICY_VERIFICATION_HISTORY,
          items: [
            {
              title: 'Search History',
              href: '/dispatch/management/policy-verification-history',
              module: MODULE.POLICY_VERIFICATION_HISTORY
            }
          ]
        },
        {
          title: 'app.navigation.settings',
          icon: SettingsIcon,
          href: '/dispatch/management/settings',
          module: MODULE.SETTINGS
        }
      ]
    }
  ]
};

const topBarConfig = {
  hidden: false,
  //   dataContextOptions: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     key: PropTypes.any,
  //     value: PropTypes.any,
  //     name: PropTypes.string,
  //     secondLine: PropTypes.string,
  //   })
  // ),
  // onDataContextChange: PropTypes.func,
  dataContextOptions: {
    enableDataContextOverride: true,
    customJSX: <CallCenterFilter />
  },
  contacts: false,
  search: false,
  notifications: true,
  settings: true
};

const guestNavConfig = {
  navBarItems: []
};

const guestTopBarConfig = {
  hidden: false,
  contacts: false,
  search: false,
  notifications: false,
  settings: false
};

const appConfig = {
  appId: 'dispatchQore-854612e6-6b2d-4d02-888c-0e7e60bdf8bd',
  appName: 'Dispatch',
  path: 'dispatch',
  icon: appIcon,
  priority: 1,
  routes: [
    {
      exact: true,
      path: 'dispatch/dispatch-schedule',
      view: lazy(() => import('src/views/dispatch/DispatchListView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.DISPATCH_BOARD,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'dispatch',
      redirect: 'reports/dashboard',
      module: MODULE.DASHBOARD,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/programs',
      view: lazy(() => import('src/views/management/ProgramsListView')),
      module: MODULE.PROGRAMS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/programs/create',
      view: lazy(() => import('src/views/management/ProgramsCreateView')),
      module: MODULE.PROGRAMS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/programs/:programId/edit',
      view: lazy(() => import('src/views/management/ProgramsEditView')),
      module: MODULE.CUSTOMERS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/customers',
      view: lazy(() => import('src/views/management/CustomerListView')),
      module: MODULE.CUSTOMERS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/customers/create',
      view: lazy(() => import('src/views/management/CustomerCreateView')),
      module: MODULE.CUSTOMERS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/customers/:customerId',
      view: lazy(() => import('src/views/management/CustomerDetailsView')),
      module: MODULE.CUSTOMERS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/customers/:customerId/edit',
      view: lazy(() => import('src/views/management/CustomerEditView')),
      module: MODULE.CUSTOMERS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/clients',
      view: lazy(() => import('src/views/management/ClientListView')),
      module: MODULE.CLIENTS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/clients/create',
      view: lazy(() => import('src/views/management/ClientCreateView')),
      module: MODULE.CLIENTS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/clients/:companyId',
      view: lazy(() => import('src/views/management/ClientDetailsView')),
      module: MODULE.CLIENTS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/clients/:companyId/edit',
      view: lazy(() => import('src/views/management/ClientEditView')),
      module: MODULE.CLIENTS,
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/services',
      view: lazy(() => import('src/views/management/ServiceListView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/services/create',
      view: lazy(() => import('src/views/management/ServiceCreateView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/services/:serviceId',
      view: lazy(() => import('src/views/management/ServiceDetailsView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/services/:serviceId/edit',
      view: lazy(() => import('src/views/management/ServiceEditView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/workflows',
      view: lazy(() => import('src/views/management/WorkflowListView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/workflows/create',
      view: lazy(() => import('src/views/management/WorkflowCreateView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/workflows/:workflowId',
      view: lazy(() => import('src/views/management/WorkflowDetailsView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/workflows/:workflowId/edit',
      view: lazy(() => import('src/views/management/WorkflowEditView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/policy-verification-history',
      view: lazy(() => import('src/views/management/PolicyRouterLogSearchView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.POLICY_VERIFICATION_HISTORY,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'management/drivers',
      view: lazy(() => import('src/views/management/DriverListView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'customer-dispatch-monitor',
      view: lazy(() => import('src/views/dispatch/DispatchCustomerView')),
      guard: GuestGuard,
      layout: MainLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'session/incomplete-sessions',
      view: lazy(() => import('src/views/dispatch/IncompleteDispatchSessions')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.SESSIONS,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'dispatch/dispatch-schedule/create',
      view: lazy(() => import('src/views/dispatch/DispatchCreateView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.DISPATCH_BOARD,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'dispatch/dispatch-schedule/retail-payment/:cashQoreTransactionId',
      view: lazy(() => import('src/views/dispatch/DispatchPORefundView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'dispatch/dispatch-schedule/:dispatchId/edit',
      view: lazy(() => import('src/views/dispatch/DispatchEditView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.DISPATCH_BOARD,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'dispatch/dispatch-schedule/:dispatchId/liveupdates',
      view: lazy(() => import('src/views/dispatch/DispatchLiveUpdatesView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.DISPATCH_BOARD,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'dispatch/dispatch-schedule/:dispatchId',
      view: lazy(() => import('src/views/dispatch/DispatchDetailsView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.DISPATCH_BOARD,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'secondary/details/:dispatchId',
      view: lazy(() => import('src/views/dispatch/SecondaryDetailsView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.DISPATCH_BOARD,
      navConfig: sharedNavConfig,
      topBarConfig
    },
    {
      exact: true,
      path: 'locate-customer',
      view: lazy(() => import('src/views/dispatch/DispatchSMSGeolocation')),
      guard: GuestGuard,
      layout: GuestLayout,
      navConfig: guestNavConfig,
      topBarConfig: guestTopBarConfig
    },
    {
      exact: true,
      path: 'customer-photo-upload',
      view: lazy(() => import('src/views/dispatch/DispatchCustomerPhotoUpload')),
      guard: GuestGuard,
      layout: GuestLayout,
      navConfig: guestNavConfig,
      topBarConfig: guestTopBarConfig
    },
    {
      exact: true,
      path: 'management/settings',
      view: lazy(() => import('src/views/management/SystemSettingsView')),
      guard: AuthGuard,
      layout: DashboardLayout,
      module: MODULE.SETTINGS,
      navConfig: sharedNavConfig,
      topBarConfig
    }
  ]
};

export default appConfig;
